import './Upload.css'
import Upload2 from './Upload2'
export default Upload2